// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4346":"pdc-widget-data-edit-dialog","9006":"pdc-widget-gantt"}[chunkId] || chunkId) + "-" + __webpack_require__.h() + ".bundle.css";
};